export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#1F2600',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#C1E800',
  },
  {
    path: 'M171.776 325.632h90.112L362.752 611.84h1.024L462.08 325.632h89.088V691.2H490.24V409.088h-1.024L387.84 691.2h-52.736l-101.376-282.112h-1.024V691.2h-60.928zM852.224 691.2H794.88v-36.864h-1.024c-14.336 26.624-46.08 44.032-75.264 44.032-69.12 0-98.816-34.816-98.816-103.936V426.496h58.368V588.8c0 46.592 18.944 63.488 50.688 63.488 48.64 0 65.024-31.232 65.024-72.192v-153.6h58.368z',
    fill: '#C1E800',
  },
]
